module.exports = __webpack_public_path__ + "assets/fonts/FWDCircularVietWeb-Black.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fwd/fonts/FWDCircularVietWeb-Black.woff
 ** module id = 1093
 ** module chunks = 0
 **/